import React, { useState } from 'react';
import Table from 'view/component/Table';
import DaftarPenyuluhan from './sub-page/daftar-penyuluhan/DaftarPenyuluhan';
// import DaftarPerubahan from './sub-page/perubahan/DaftarPerubahan';
// import DaftarPIRT from './sub-page/daftar-pirt/DaftarPIRT';
// import Container from '../../modules/Container';
import CekPendaftaran from './sub-page/cek-pendaftaran/CekPendaftaran';
import { Redirect, Route, Switch, Link } from "react-router-dom";


const menu = [
  { title: 'Pendaftaran Penyuluhan', tab: 'daftar-penyuluhan', icon: 'ni ni-badge' },
  // { title: 'Pendaftaran PIRT', tab: 'daftar-pirt', icon: 'ni ni-single-copy-04' },
  // { title: 'Perpanjangan / Perubahan', tab: 'perpanjangan', icon: 'ni ni-paper-diploma' },
  { title: 'Cek Pendaftaran', tab: 'cek-pirt', icon: 'fa fa-search-plus' },
];

const Content = (props) => {
  return (
    <>
      {/* <Container marginTop={ 7 } full>
        <div className="row">
          <div className="col-md-3">
            <div
              className="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              {menu.map((m, k) => (
                <a
                  className="nav-link"
                  id="v-pills-home-tab"
                  data-toggle="pill"
                  href={ `#${ m.tab }` }
                  key = {k}
                  role="tab"
                  onClick={() => props.history.push("/service/pirt")}
                >
                  {m.title}
                </a>
              ))}
            </div>
          </div>
          <div className="col-md-9">
            <div className="tab-content" id="v-pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="cek-pirt"
                role="tabpanel"
              >
                <h2>Cek PIRT</h2>
                <CekPendaftaran />
              </div>
              <div
                className="tab-pane fade"
                id="daftar-penyuluhan"
                role="tabpanel"
              >
                <h2>Pendaftaran Penyuluhan</h2>
                {/* <FormPersyaratanPenyuluhan /> */}
      {/* <DaftarPenyuluhan />
              </div>
              <div className="tab-pane fade" id="daftar-pirt" role="tabpanel">
                <h2>Pendaftaran PIRT</h2>
                <DaftarPIRT />
              </div>
              <div className="tab-pane fade" id="perubahan" role="tabpanel">
                <h2>Perpanjangan / Perubahan</h2>
                <Perubahan />
              </div>
            </div>
          </div>
        </div>
      </Container> */}
      <div className="mt-7">
        <Switch>
          <Redirect
            exact={true}
            from="/service/pirt"
            to="/service/pirt/home"
          />

          <Route
            path="/service/pirt/cek-pirt"
            component={() => (
              <CekPendaftaran />
            )}
          />
          <Route
            path="/service/pirt/daftar-penyuluhan"
            component={() => (
              <DaftarPenyuluhan />
            )}
          />
          {/* <Route
            path="/service/pirt/daftar-pirt"
            component={() => (
              <DaftarPIRT />
            )}
          />
          <Route
            path="/service/pirt/perpanjangan"
            component={() => (
              <DaftarPerubahan />
            )}
          /> */}
           <Route exact path="/service/pirt/home" component={ContentRoute} />
        </Switch>
      </div>
    </>
  );
};

const ContentRoute = (props) => {
  return (
    <div className="row mt-7 ml-4 mr-2">
      {menu.map((m, k) => (
        <div className="col-12 col-md-6 col-lg-3 mb-5 mb-lg-0 text-center">
          <Link to={`/service/pirt/` + m.tab}>
            <div className="card ml-2">
              <div className="card-header text-center"> {m.title} </div>
              <div className="card-body text-center">
                <div className="icon icon-shape icon-shape-primary rounded-circle">
                  <i className={m.icon} />
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  )
}

export default Content;
